var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "menu-item-content", class: { "is-close": _vm.collapse } },
    [
      _c("i", { class: ["wk", `wk-${_vm.icon}`] }),
      _vm._v(" "),
      _c("span", { staticClass: "side-bar-label" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm._v(" "),
      _vm.count
        ? _c("span", [_vm._v("(" + _vm._s(_vm.count) + ")")])
        : _vm._e(),
      _vm._v(" "),
      _vm.num && _vm.num > 0
        ? _c("el-badge", { attrs: { max: 99, value: _vm.num } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }